<template>
  <div v-if="showList">
    <h1>Produkte</h1>
    <table class="table table-sm table-hover clickable">
      <thead>
      <tr>
        <th scope="col">Name</th>
      </tr>
      </thead>
      <tbody>
      <tr
          v-for="entry in getListItems()"
          :key="entry.productId"
          @click="cruElement(entry.productId)">
<!--        <th scope="row">{{ entry.productId }}</th>-->
        <td>{{ entry.name }}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <product-editor v-if="formOpened" :element-id="elementId" @closeForm="closeForm"/>
  <app-btn-back class="pt-2"/>
  <app-btn-add v-if="!formOpened" @click="openForm"/>
</template>

<script>
import ProductEditor from "@/components/ProductEditor";

export default {
  name: "ProductPage",
  components: {ProductEditor},
  data() {
    return {
      showList: true,
      formOpened: false,
      elementId: null,
      list: null
    }
  },
  created() {
    this.$store.dispatch('getItemList', {entityName:'product'})
  },
  methods: {
    getListItems(){
      return this.$store.state.product
    },
    cruElement(id) {
      this.elementId = id
      this.showList = false
      this.formOpened = true
    },
    openForm() {
      this.showList = false
      this.formOpened = true
    },
    closeForm() {
      this.formOpened = false
      this.showList = true
      this.elementId = null
    }
  }
}
</script>

<style scoped>

</style>